import type { AxiosRequestConfig } from 'axios'

import { HttpService } from '@/infra'
import type { TGruposDeUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'

export class GetGruposDeUnidadesDeNegocioDisponiveisService extends HttpService {
  execute = async () => {
    return this.http.get<TGruposDeUnidadesDeNegocioDisponiveisResponse, AxiosRequestConfig>(
      `api/v2/GrupoUnidadesDeNegocio/disponiveis`,
    )
  }
}
